export enum PaymentTermsEnum {
    DAYS_30 = 'days_30',
    DAYS_45 = 'days_45',
    DAYS_60 = 'days_60',
    DAYS_90 = 'days_90',
    OTHER = 'other',
}
